<template>
    <div class="box">
        <el-dialog custom-class="login-dialog" :append-to-body="true" :show-close="false"
            :visible.sync="loginDialogVisible">
            <div class="qr_container">
                <h3>验证码登录</h3>
                <input type="text" v-model="mobile" oninput="value=value.replace(/[^\d]/g,'')" id="phoneNumber"
                    maxlength="11" placeholder="请输入手机号">
                <span class="remindName phoneRemind" v-show="mobileErr" style="width: 100%;height:20px">请输入正确的手机号码</span>

                <div class="qrCode-box">
                    <input type="text" v-model="qrCode" oninput="value=value.replace(/[^\d]/g,'')" placeholder="请填写短信验证码"
                        maxlength="6" style="width: 65%;vertical-align: inherit" id="code">
                    <button class="verifyCodeBtn" :class="{ disabled: qrCodeBtnDisabled }" :disabled="qrCodeBtnDisabled"
                        @click="getVerifyCode()">{{ !qrCodeBtnDisabled ? '获取验证码' :
                            `${time}s` }}</button>
                </div>
                <span class="remindName codeRemind" v-show="qrCodeErr" style="width: 100%;height:20px">请输入正确的验证码</span>

                <button class="loginBtn" @click="userToLogin()">登录</button>
                <p style="margin-top: 30px;text-align: center;">我同意本站免责声明</p>
                <button class="closeBtn" @click="isLogin"></button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import MaskPopup from './MaskPopup.vue';
import { mapState } from 'vuex'
export default {
    components: {
        MaskPopup
    },
    data() {
        return {
            mobile: '',
            mobileErr: false,
            qrCode: '',
            qrCodeErr: false,
            time: 60,
            timer: null,
            loginDialogVisible: false,
        }
    },
    created() {

    },
    methods: {
        getVerifyCode() {
            if (this.timer) return;
            const { mobile } = this;
            if (mobile.length < 11) return this.mobileErr = true;
            this.mobileErr = false;
            this.$axios.post(this.$ApiInfo.getQrCode, "data=" + JSON.stringify({ mobile }), false).then(res => {
                this.timer = setInterval(() => {
                    this.time--;
                    if (this.time == 0) {
                        clearInterval(this.timer);
                        this.timer = null;
                        this.time = 60;
                    }
                }, 1000);
            })
        },
        userToLogin() {
            const { mobile, qrCode } = this;
            if (mobile.length < 11) return this.mobileErr = true;
            if (qrCode.length < 6) return this.qrCodeErr = true;

            this.mobileErr = false;
            this.qrCodeErr = false;
            this.$axios.post(this.$ApiInfo.login, "data=" + JSON.stringify({ mobile, code: qrCode }), false).then(data => {
                this.$store.commit('setUserInfo', data);
                sessionStorage.setItem('userInfo', JSON.stringify(data))
                this.close();
                data.isNew = 1;
                // debugger
                this.$bus.$emit('loginSuccess',data);
            })
        },
        isLogin() {
            this.loginDialogVisible = false;
        },
        open() {
            this.loginDialogVisible = true;
        },
        close() {
            this.loginDialogVisible = false;
        }
    },
    computed: {
        ...mapState(['userInfo']),
        qrCodeBtnDisabled() {
            return this.timer && true
        }
    }
}
</script>
<style lang="less">
.login-dialog {
    display: inline;

    .el-dialog__header {
        display: none;
    }

    .el-dialog__body {
        padding: 0;
        display: flex;
        min-height: 100vh;
        align-items: center;
        justify-content: center;
    }
}

.qr_container {
    position: relative;
    margin: 0 auto;
    margin-top: -150px;
    box-sizing: border-box;
    width: 400px;
    padding: 10px 30px;
    background-color: #fff;
    color: #000;
    text-align: left;

    .qrCode-box {
        display: flex;
        align-items: center;
    }

    .verifyCodeBtn {
        margin-top: 20px;
        width: 28%;
        height: 40px;
        margin-left: 3%;
        background-color: rgb(0, 111, 183);
        color: #fff;
        border: none;
        border-radius: 3px;
        cursor: pointer;
    }

    p {
        line-height: 18px;
        margin: 0;
        color: #999;
    }

    h3 {
        text-align: center;
        position: relative;
        font-size: 18px;
        margin-top: 10px;
        margin-bottom: 20px;
        font-weight: 400;

        &::after {
            display: block;
            position: absolute;
            content: '';
            width: 30px;
            height: 4px;
            background-color: rgb(0, 111, 183);
            left: 50%;
            transform: translateX(-50%);
        }
    }

    input {
        vertical-align: middle;
        margin-top: 20px;
        outline: 0;
        border: 1px solid #d7d7d7;
        border-radius: 3px;
        text-indent: 1em;
        font-size: 16px;
        width: 100%;
        height: 40px;
    }

    .remindName {
        color: red;
        font-size: 14px;
        margin-left: 10px;
    }

    button.disabled {
        opacity: .5;
        cursor: not-allowed;
    }

    .loginBtn {
        width: 100%;
        height: 40px;
        margin-top: 30px;
        font-size: 18px;
        background-color: rgb(0, 111, 183);
        color: #fff;
        border: none;
        border-radius: 3px;
        cursor: pointer;
    }

}

.newUser_container {
    position: relative;
    box-sizing: border-box;
    padding: 20px;
    background-color: #fff;
    height: 250px;
    width: 465px;
    border-radius: 3px;

    h3 {
        text-align: center;
    }

    button {
        border: none;
    }

    .userIcon {
        display: inline-block;
        vertical-align: middle;
        height: 32px;
        width: 32px;
        background-image: url(https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/user.png);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        border-radius: 50%;
        text-align: center;
        overflow: hidden;
    }

    .closeTip {
        margin-top: 4px;
        width: 24px;
        height: 24px;
        position: absolute;
        right: 0;
        top: 0;
        background: url(https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/close-pink.png) center no-repeat;
        cursor: pointer;
    }
}

.closeBtn {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    position: absolute;
    bottom: -46px;
    left: 50%;
    margin-left: -16px;
    border: none;
    background-color: #cdcdcd;
    background-image: url(https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/close.png);
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}</style>